var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#FF4D61"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15V79H79V15H15ZM17.666 17.7345H76.332V76.2634H17.666V17.7345ZM37.198 51.2423L35.084 59.4377C35.042 59.6736 34.958 59.7147 34.698 59.7147H30.782C30.512 59.7147 30.47 59.6285 30.512 59.3187L38.084 32.117C38.22 31.6247 38.302 31.1877 38.344 29.8297C38.344 29.6471 38.438 29.563 38.574 29.563H44.158C44.336 29.563 44.428 29.6061 44.47 29.8297L52.96 59.3618C53.012 59.5854 52.96 59.7147 52.742 59.7147H48.346C48.116 59.7147 47.992 59.6613 47.95 59.4788L45.742 51.2403H37.19L37.198 51.2423ZM44.636 46.7969C43.886 43.7731 42.126 37.1491 41.47 33.9428H41.418C40.856 37.1368 39.438 42.5546 38.346 46.7969H44.636ZM56.636 31.5939C56.636 29.8317 57.824 28.7937 59.366 28.7937C60.992 28.7937 62.096 29.9261 62.096 31.5939C62.096 33.3991 60.95 34.3941 59.314 34.3941C57.72 34.3941 56.626 33.4012 56.626 31.5939H56.636ZM56.938 37.8117C56.938 37.5984 57.022 37.5122 57.24 37.5122H61.428C61.668 37.5122 61.75 37.5984 61.75 37.8322V59.4254C61.75 59.649 61.708 59.7352 61.438 59.7352H57.312C57.042 59.7352 56.958 59.6059 56.958 59.3823V37.8097L56.938 37.8117Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD6);
export default __webpack_public_path__ + "static/media/d6.445e36147c214a12c3ba4be6ec2277fc.svg";
export { ForwardRef as ReactComponent };